// extracted by mini-css-extract-plugin
export default {"variantsContainer":"ClassicQuiz_variantsContainer__g3kJ2"};